import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Route guard: redirects to /login if not authenticated,
 * redirects to /mfa-setup if MFA is required but not configured.
 */
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store';
import { authApi } from '../services/api-client';
export function ProtectedRoute({ loginPath = '/login', mfaSetupPath = '/mfa-setup', skipMfaCheck = false }) {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const mfaConfigured = useAuthStore((s) => s.mfaConfigured);
    const setMfaConfigured = useAuthStore((s) => s.setMfaConfigured);
    const location = useLocation();
    const [checking, setChecking] = useState(mfaConfigured === null && !skipMfaCheck);
    useEffect(() => {
        if (!isAuthenticated || skipMfaCheck || mfaConfigured !== null)
            return;
        authApi.get('/auth/mfa-setup/status')
            .then(({ data }) => {
            setMfaConfigured(!data.mfaRequired);
            setChecking(false);
        })
            .catch(() => {
            // If status check fails, assume MFA is configured (don't block access)
            setMfaConfigured(true);
            setChecking(false);
        });
    }, [isAuthenticated, mfaConfigured, skipMfaCheck, setMfaConfigured]);
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: loginPath, state: { from: location }, replace: true });
    }
    if (checking) {
        return null; // Show nothing while checking MFA status
    }
    if (mfaConfigured === false && !skipMfaCheck) {
        return _jsx(Navigate, { to: mfaSetupPath, replace: true });
    }
    return _jsx(Outlet, {});
}
//# sourceMappingURL=ProtectedRoute.js.map